import { render, staticRenderFns } from "./Restauration.vue?vue&type=template&id=69b3ba92&"
import script from "./Restauration.vue?vue&type=script&lang=js&"
export * from "./Restauration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports